import { IntrinsicProps, createComponent, ButtonLink } from 'react-commons';

import style from './index.module.scss';
import { useRouter } from 'next/router';

export interface NavButtonLinkProps extends IntrinsicProps {
  href: string
}

export default createComponent('NavButtonLink', { style }, ({ className }, props: NavButtonLinkProps) => {

  const router = useRouter();
  
  return (
    <ButtonLink 
      className={className}
      href={props.href} 
      secondary={router.asPath === props.href}
      rounded
    >
      {props.children}
    </ButtonLink>
  );

});